import { CreditsConfig } from "src/types/credits";

export const creditsConfig: CreditsConfig = {
  resons: {},
};
